import { useEffect, useState } from "react"
import { getStatesListForCountryName } from "../countryStateData.js"

/**
 * State/province rows for the given country (bundled assets).
 * Option values are `state_code` (2-letter); labels are `name`.
 * @param {string} countryName — e.g. "Canada", "United States"
 * @param {{ id: number, name: string }[]} [countries]
 */
export function useRegionOptions(countryName, countries = []) {
    const [regions, setRegions] = useState(
        /** @type {{ state_code: string, name: string }[]} */ ([])
    )

    useEffect(() => {
        if (!countryName) {
            setRegions([])
            return
        }
        setRegions(getStatesListForCountryName(countryName, countries))
    }, [countryName, countries])

    return regions
}
